module.exports = __webpack_public_path__ + "media/images/icon/icons8-Zoom Out-059eac42453891f4afe80be079b70e83.png";